export { default } from './FormEventTickets.vue'
